import React from 'react'
import PropTypes from 'prop-types'
import fontStyles from 'src/assets/styles/fontStyles.module.scss'
import generalStyles from 'src/assets/styles/generalStyles.module.scss'

const TypeProps = {
  id: PropTypes.any,
  group: PropTypes.any,
  label: PropTypes.string,
  selected: PropTypes.bool,
  onClick: PropTypes.func,
  value: PropTypes.any,
  boldOnSelected: PropTypes.bool,
  textMarginOverride: PropTypes.any
}

const RadioButton = ({ id, label, selected, onClick, value, textMarginOverride = null, group='' }) => {
  return (
    <div data-testid={`radioInput${id}`} className={generalStyles.flexRow}>
      <input
        type="radio"
        key={`radio-input-${id}`}
        id={id}
        name={group}
        checked={selected}
        value={value}
        onChange={() => onClick(value)}
        className={textMarginOverride || generalStyles.mr20}
      />
      <label key={id} className={ selected ? fontStyles.psmallboldlsin08blackgraphik15pt : fontStyles.psmalllsin08blackgraphik15pt}>
        {label}
      </label>
    </div>
  )
}

RadioButton.propTypes = {
  ...TypeProps
}

export default RadioButton
